/** Fixed height (px) of the logged-out lp-v3 marketing nav bar; page content offsets by this. */
export const LP_V3_NAV_HEIGHT = 64

/** Golden entrance easing (design-with-taste): fast start, gentle settle. */
export const LP_V3_EASE = 'cubic-bezier(0.16, 1, 0.3, 1)'
